import { toastrStateType } from 'src/reducers/toastr';

export const SET_TOASTR = 'toastr/SET_TOASTR';

export const setToastr = (value: Partial<toastrStateType>) => {
  return (dispatch) => {
    dispatch({ type: SET_TOASTR, data: value });
  };
};
